import { TimelineInterval } from "../Api/StatsTimelineApi";
import { ValueChartDataProvider, ValueChartItem } from "../Components/PercentValueChart/ValueChart";

export const days = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun",
];

/**
 * Represents the popularity stats data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default class DailyPopularityStats implements ValueChartDataProvider {
    public readonly data: ValueChartItem[];
    public readonly interval: TimelineInterval = "day";
    public readonly from: string | null;
    public readonly to: string | null;

    constructor(
        data: number[] = [],
        from: string | null = null,
        to: string | null = null,
    ) {
        this.data = [];
        this.from = from;
        this.to = to;

        const limit = 7;
        for (let i: number = 0; i < limit; i++) {
            const day = days?.[i % days.length];
            if (day) {
                this.data.push({
                    name: "" + day,
                    value: data?.[i] || 0,
                    children: [],
                });
            }
        }
    }

    /**
     * Converts the class into the data structure used by the charts
     * The data structure was designed as part of the legacy
     * application into this. 
     */
    public getChartData(): ValueChartItem[] {
        return this.data;
    }
    public getRawData(): ValueChartItem[] {
        return this.data;
    }

    public getChartLabels(): string[] {
        return Object.values(this.getChartData()).map((item) => item.name);
    }

    getChartTotal(): number {
        return this.data.reduce((carry, item) => carry += item.value, 0);
    }
}
